import { useMemo, memo } from 'react';
// @ts-expect-error Not typed
import CurrencySelect from 'ui-addon-i18n/components/CurrencySelect';
import { MULTI_CURRENCY_CURRENCY_CODE } from 'reference-resolvers-lite/constants/ReferenceTypes';
import { usePagedSearchResolver } from 'reference-resolvers-lite/ResolverHooks';
import { isError, isLoading } from 'reference-resolvers-lite/Status';
import isString from 'transmute/isString';
import { useCachedResolver } from '../resolvers/hooks/useCachedResolver';

// Query must be set as an empty string to fetch all results, we are guaranteed
// to get all currency results with this query because HubSpot only supports
// around 175 currencies
import { jsx as _jsx } from "react/jsx-runtime";
const allCurrenciesSearchQuery = {
  count: 1000,
  query: '',
  offset: 0
};
const PropertyInputMultiCurrencyCurrencyCodeV2 = ({
  autoFocus,
  buttonUse,
  className,
  'data-selenium-test': dataSeleniumTest,
  'data-test-id': dataTestId,
  defaultOpen,
  disabled,
  inputRef,
  readOnly,
  onChange,
  value
}) => {
  const resolver = useCachedResolver(MULTI_CURRENCY_CURRENCY_CODE);
  const {
    status,
    results
  } = usePagedSearchResolver(resolver, allCurrenciesSearchQuery);
  const currencyCodes = useMemo(() => {
    if (!results || isError(status) || isLoading(status)) {
      return new Set();
    }
    const {
      references
    } = results;
    const parsedCurrencyCodes = references.map(reference => reference.id);

    // If there is a currency set as the value that for some reason is now
    // archived we still want to show it
    if (isString(value)) {
      parsedCurrencyCodes.unshift(value);
    }
    return new Set(parsedCurrencyCodes);
  }, [results, status, value]);
  return /*#__PURE__*/_jsx(CurrencySelect, {
    autoFocus: autoFocus,
    buttonUse: buttonUse,
    "data-test-id": dataTestId,
    "data-selenium-test": dataSeleniumTest,
    defaultOpen: defaultOpen,
    className: className,
    readOnly: readOnly,
    disabled: disabled,
    currenciesFilter: currencyOption => currencyCodes.has(currencyOption.value),
    currencyStyle: "long",
    onChange: onChange,
    ref: inputRef,
    value: value
  });
};
export default /*#__PURE__*/memo(PropertyInputMultiCurrencyCurrencyCodeV2);